import { render, staticRenderFns } from "./step-two.vue?vue&type=template&id=f04413e4&scoped=true&"
import script from "./step-two.vue?vue&type=script&lang=js&"
export * from "./step-two.vue?vue&type=script&lang=js&"
import style0 from "./step-two.vue?vue&type=style&index=0&id=f04413e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04413e4",
  null
  
)

export default component.exports